import axios from 'axios';
import Constants from './utils/Constants';

axios.defaults.baseURL = `${Constants.IS_HTTPS ? 'https' : 'http'}://${process.env.REACT_APP_SERVER_HOST || window.location.host}`;
axios.defaults.headers.common['X-Requested-With'] = Constants.X_REQUESTED_WITH_HEADER;
